import gql from 'graphql-tag';

const abTestQuery = gql`
  query abTestQuery {
    abTests {
      variant
      isEligible
      id
      name
      interstate
    }
  }
`;

export default abTestQuery;
